module.exports = __webpack_public_path__ + "static/media/health13.05b3f375.svg";